import * as DictionaryConstants from '../../../../../../constants/DictionaryConstants'
import * as RoutePathConstants from '../../../../../../constants/RoutePathConstants'

export default {
  data () {
    return {

    }
  },
  methods: {

  },
  mounted () {

  }
}



// WEBPACK FOOTER //
// ./src/pages/wx-member/points-mall/page-mail-service/views/oil-card-recharge/oil-card-recharge.js